import axios from "axios";
import { loginFailure, loginStart, loginSuccess } from "./AuthActions";
const api = axios.create({
  baseURL: process.env.REACT_APP_API,
  withCredentials: true,
});
export const login = async (user, dispatch) => {
  dispatch(loginStart());
  try {
    const res = await api.post("auths/login", user);
    dispatch(loginSuccess(res.data));
    return res.data;
  } catch (err) {
    const data = err.response?.data;
    const message = err.response
      ? typeof data === "string"
        ? data
        : data?.error || data?.message || "Login failed"
      : "Cannot reach the server. Check your connection and try again.";
    dispatch(loginFailure(message));
    throw err; // so the page knows login failed (and can read needsVerification)
  }
};
